import { Component, OnInit, Inject } from '@angular/core';
import { Travel } from 'src/app/models/travel';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material';
import { TravelService } from '../../services/travel/travel.service';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { DatePipe } from '@angular/common';

import * as _moment from 'moment';

import {defaultFormat as _rollupMoment} from 'moment';
import { AddressService } from 'src/app/modules/shared/services/address/address.service';
import { TravelBookingAddComponent } from '../travel-booking-add/travel-booking-add.component';
import { TravelBookingViewComponent } from '../travel-booking-view/travel-booking-view.component';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { TRANSPORTATION, SPECIAL_TRANSPORTATION } from 'src/app/modules/shared/common/api';
import { LookUpLocationComponent } from 'src/app/modules/shared/components/look-up-location/look-up-location.component';
import { NotifyboxComponent } from 'src/app/modules/shared/components/notifybox/notifybox.component';
import { ConfirmationMessageComponent } from 'src/app/modules/shared/components/confirmation-message/confirmation-message.component';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY-MM-DD',
    dateA11yLabel: 'YYYY-MM-DD',
    monthYearA11yLabel: 'YYYY-MM-DD',
  },
};

@Component({
  selector: 'app-travel-summary-add',
  templateUrl: './travel-summary-add.component.html',
  styleUrls: ['./travel-summary-add.component.scss']
})
export class TravelSummaryAddComponent implements OnInit {

  travel: Travel;
  formGroup: FormGroup;
  booking_details_list: any;
  loading:boolean = false;
  isBook:boolean = false;
  isBookrequired:boolean = false;
  isModePlaneOrFerry: boolean = false;
  successMessage: String = '';
  bookingmsg = '';
  index = 0;
  total = 0;
  mealTotal = 0;
  msg:any;
  option =  {
    btnOk:'Yes',
    btnCancel: 'Cancel',
  }
  temporaryValue = {};
  transportationOption = TRANSPORTATION;
  specialModeOfTransportation = SPECIAL_TRANSPORTATION;

  err_handle_msg_org_cty = 'The country field is required.';
  err_handle_msg_dst_cty = 'The country field is required.';

  err_handle_msg_org_dstn = 'The province field is required.';
  err_handle_msg_prov_dstn = 'The province field is required.';

  err_handle_msg = 'The city field is required.';
  err_handle_msg_dstn = 'The city field is required.';

  err_handle_msg_org_brgy = 'The barangay field is required.';
  err_handle_msg_dstn_brgy = 'The barangay field is required.';

  err_origin_handle_msg = 'The state field is required.';
  err_destination_handle_msg = 'The state field is required.';

  dialogConfig:any;
  summaryDetail:any;
  isCountry: boolean = true;
  isDestinationCountry: boolean = true;
  pipe = new DatePipe('en-US');

  updatedOriginCountry:any;
  updatedDestinationCountry:any;
  updatedOriginCity:any;
  updatedDestinationCity:any;
  updatedOriginBrgy:any;
  updatedDestinationBrgy:any;

  autosuggest = {
    'origin_barangay': '',
    'destination_barangay':'',
    'origin_country': null,
    'destination_country': null,
    'origin_city_municipality': null,
    'destination_city_municipality':null,
  };

  province = JSON.parse(localStorage.getItem('province'));
  city = [];
  barangay = [];
  cityList = {
    origin:JSON.parse(localStorage.getItem('citylist')),
    destination:JSON.parse(localStorage.getItem('citylist'))
  };
  barangayList = {
    origin:[],
    destination:[]
  };
  country = JSON.parse(localStorage.getItem('country'));
  filterCountry: Observable<string[]>;
  filterDestinationCountry: Observable<string[]>;
  filterProvince: Observable<string[]>;
  filterDestinationProvince: Observable<string[]>;
  filtercityOrigin:Observable<string[]>;
  filtercityDestination:Observable<string[]>;
  filterBarangayOrigin:Observable<string[]>;
  filterBarangayDestination:Observable<string[]>;

  constructor(
    public dialogRef: MatDialogRef<TravelSummaryAddComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public travelService: TravelService,
    public addressService: AddressService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.travel = this.data.travel;
    this.formGroup = this.formBuilder.group({
      mode_of_transportation: ['',null],
      transportation_cost : ['',null],
      origin_country:['',null],
      destination_country: ['',null],
      origin_city_municipality: ['',null],
      origin_barangay: ['',null],
      destination_city_municipality: ['',null],
      destination_barangay: ['',null],
      travel_itinerary_bookings:['',null],
    });

    this.formGroup.controls['origin_barangay'].disable();
    this.formGroup.controls['destination_barangay'].disable();
    this.formGroup.controls['travel_itinerary_bookings'].disable(); 

    //this.formGroup.controls['travel_authorization_id'].setValue(this.travel.id);
    this.formGroup.get('mode_of_transportation').valueChanges.subscribe(value => { 
      if (value == 'Airplane') {
        this.isBook = true;
        this.formGroup.controls['travel_itinerary_bookings'].enable();
      } else {
        this.isBook = false;
        this.travel.booking_details_temp = [];
        this.formGroup.controls['travel_itinerary_bookings'].disable();
        this.formGroup.controls['travel_itinerary_bookings'].setValue('');
        this.formGroup.controls['transportation_cost'].setValue('');
      }

      if (value == "Airplane" || value == "Ferry" || value == "None") {
        this.formGroup.controls['transportation_cost'].setValue('');
        this.isModePlaneOrFerry = true;
      } else {
        this.isModePlaneOrFerry = false;
      }
    });
    this.travel.formGroup = this.formGroup;
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.position = {
      'top': '0',
      'right': '0',
    }
    this.dialogConfig.width = '800px';
    this.dialogConfig.height = '100%';
    this.dialogConfig.disableClose = true;
    this.dialogConfig.panelClass = 'mat-dialog';

    this.filterCountry = this.formGroup.get('origin_country').valueChanges
    .pipe(startWith(''),map(val => this._filter(val)));

    this.filterDestinationCountry = this.formGroup.get('destination_country').valueChanges
    .pipe(startWith(''),map(val => this._filter(val)));

    // this.filterProvince = this.formGroup.get('origin').valueChanges
    // .pipe(startWith(''),map(val => this._filter(val,1)));

    // this.filterDestinationProvince = this.formGroup.get('destination').valueChanges
    // .pipe(startWith(''),map(val => this._filter(val,1)));

    this.filtercityOrigin = this.formGroup.get('origin_city_municipality').valueChanges
    .pipe(startWith(''),map(val => this._filter(val,2,'origin')));

    this.filterBarangayOrigin = this.formGroup.get('origin_barangay').valueChanges
    .pipe(startWith(''),map(val => this._filter(val,3,'origin')));

    this.filtercityDestination = this.formGroup.get('destination_city_municipality').valueChanges
    .pipe(startWith(''),map(val => this._filter(val,2,'destination')));

    this.filterBarangayDestination = this.formGroup.get('destination_barangay').valueChanges
    .pipe(startWith(''),map(val => this._filter(val,3,'destination')));

    this.updatedOriginCountry = this.formGroup.controls['origin_country'].value;
    this.updatedDestinationCountry = this.formGroup.controls['destination_country'].value;
    this.updatedOriginCity = this.formGroup.controls['origin_city_municipality'].value;
    this.updatedDestinationCity = this.formGroup.controls['destination_city_municipality'].value;

    this.formGroup.get('origin_country').valueChanges.subscribe(value => {
      this.changeCountry(value,'origin_country');
      this.updatedOriginCountry = value;
    });
  
    this.formGroup.get('destination_country').valueChanges.subscribe(value => {
      this.changeDestinationCountry(value,'destination_country')
      this.updatedDestinationCountry = value;
    });
  
    this.formGroup.get('origin_city_municipality').valueChanges.subscribe(value => {
      this.changeBarangay(value.citymunCode,'origin','origin_city_municipality',value);
      this.updatedOriginCity = value;
      if (this.formGroup.value.origin_city_municipality != value) {
        this.formGroup.controls['origin_barangay'].setValue('');
      }
    });
  
    this.formGroup.get('destination_city_municipality').valueChanges.subscribe(value => {
      this.changeBarangay(value.citymunCode,'destination','destination_city_municipality',value);
      this.updatedDestinationCity = value;
      if (this.formGroup.value.destination_city_municipality != value) {
        this.formGroup.controls['destination_barangay'].setValue('');
      }
    });

  }
  
  closeOnClick() {
    this.travel.booking_details_temp = [];
    this.dialogRef.close('');
  }

  keypressValidateNumber(e,max) {
    const pattern = new RegExp(/^\d*\.?\d{0,2}$/g); // '\d'
    return pattern.test(e.key);
  }

  /**
   * Number validation on input fields
   */  
  keypressValidateNumberDecimal(e) {
    const pattern = new RegExp(/^\d*\.?\d{0,2}$/g);
    const rgx = /^[0-9]*\.?[0-9]*$/;
    if ((e.key == '.' && e.target.value.includes('.')) || !pattern.test(e.key)) {
      return false;
    }
    return (e.target.value.match(rgx)) ? true : false;
  }

  save(){

    Object.keys(this.formGroup.controls).forEach(key => {
      let arr = ['origin_barangay','destination_barangay'];

      if (!this.formGroup.controls[key].disabled) {

        if (this.isDestinationCountry && key == 'destination_city_municipality') {
          return true;
        }

        if (this.isCountry && key == 'origin_city_municipality') {
          return true;
        }


        if (this.autosuggest[key] == null  && 
          !(key == 'mode_of_transportation') && 
          !(key == 'transportation_cost') ) {
            if (!(key == 'origin_country') && !(key == 'destination_country') && !(key == 'origin_barangay') && !(key == 'transportation_cost') && !(key == 'destination_barangay') && !(key == 'travel_itinerary_bookings')) {
              this.formKey(key);
            }
        }

        if (key == 'travel_itinerary_bookings' && this.formGroup.controls[key].value == '' && this.formGroup.controls['mode_of_transportation'].value == "Airplane") {
          this.formKey(key);
          this.isBookrequired = true;
          return true;
        }

        if (this.formGroup.controls[key].value == '' && !arr.includes(key)) {
          if (!(key == 'origin_barangay') && !(key == 'transportation_cost') && !(key == 'destination_barangay') && !(key == 'travel_itinerary_bookings')) {
            this.formKey(key);
          }
        }
      }
    });

    var format = /^[\\d*#+A-Za-z ]+$/;
    const validateOriginCountry = this.country.filter(option => option.toLowerCase() === this.updatedOriginCountry.toLowerCase()).length;
    const validateDestinationCountry = this.country.filter(option => option.toLowerCase() === this.updatedDestinationCountry.toLowerCase()).length;

    if (this.formGroup.controls['origin_country'].value != '' && validateOriginCountry == 0) {
      this.err_handle_msg_org_cty = 'The value indicated is not found on the list.';
      this.formKey('origin_country');
    }

    if (this.formGroup.controls['destination_country'].value != '' && validateDestinationCountry == 0) {
      this.err_handle_msg_dst_cty = 'The value indicated is not found on the list.';
      this.formKey('destination_country');
    }

    if (!this.isCountry) {
      const validateOriginCity = this.cityList['origin'].filter(option => option.title.toLowerCase() === this.updatedOriginCity.toLowerCase()).length;

      if (this.formGroup.controls['origin_city_municipality'].value != '' && (validateOriginCity == 0 || validateOriginCity == undefined)) {
        this.err_handle_msg = 'The value indicated is not found on the list.';
        this.formKey('origin_city_municipality');
      } 
      
      if (this.formGroup.controls['origin_city_municipality'].value == '') {
        this.err_handle_msg = 'The city field is required.';
        this.formKey('origin_city_municipality');
      }

      if (this.formGroup.controls['origin_barangay'].value != '') {
        const validateOriginBarangay = this.barangayList['origin'].filter(option => option.brgyDesc.toLowerCase() === this.formGroup.controls['origin_barangay'].value.toLowerCase()).length;
        this.err_handle_msg_org_brgy = 'The value indicated is not found on the list.';
        if (validateOriginBarangay == 0) {
          this.formKey('origin_barangay');
        }
      }
    } else {
      if (this.formGroup.controls['origin_city_municipality'].value == '') {
        this.formKey('origin_city_municipality');
      }else{
        if (this.formGroup.controls['origin_city_municipality'].value.length < 3) {
          this.err_origin_handle_msg = 'The state field must be at least 3 characters.';
          this.formKey('origin_city_municipality');
        }else if (!format.test(this.formGroup.controls['origin_city_municipality'].value) ){
          this.err_origin_handle_msg = 'The data inputted is invalid.';
          this.formKey('origin_city_municipality');
        }
      }
    }

    if (!this.isDestinationCountry) {
      const validateDestinationCity = this.cityList['destination'].filter(option => option.title.toLowerCase() === this.updatedDestinationCity.toLowerCase()).length;
      
      if (this.formGroup.controls['destination_city_municipality'].value != '' && (validateDestinationCity == 0 || validateDestinationCity == undefined)) {
        this.err_handle_msg_dstn = 'The value indicated is not found on the list.';
        this.formKey('destination_city_municipality');
      } 
      
      if (this.formGroup.controls['destination_city_municipality'].value == '') {
        this.err_handle_msg_dstn = 'The city field is required.';
        this.formKey('destination_city_municipality');
      }

      if (this.formGroup.controls['destination_barangay'].value != '') {
        const validatDstnBarangay = this.barangayList['destination'].filter(option => option.brgyDesc.toLowerCase() === this.formGroup.controls['destination_barangay'].value.toLowerCase()).length;
        this.err_handle_msg_dstn_brgy = 'The value indicated is not found on the list.';
        if (validatDstnBarangay == 0) {
          this.formKey('destination_barangay');
        }
      }
    } else {
      if (this.formGroup.controls['destination_city_municipality'].value == '') {
        this.formKey('destination_city_municipality');
      }else{
        if (this.formGroup.controls['destination_city_municipality'].value.length < 3) {
          this.err_destination_handle_msg = 'The state field must be at least 3 characters.';
          this.formKey('destination_city_municipality');
        }
        else if (!format.test(this.formGroup.controls['destination_city_municipality'].value) ){
          this.err_destination_handle_msg = 'The data inputted is invalid.';
          this.formKey('destination_city_municipality');
        }
      }
    }

    if (!(this.specialModeOfTransportation.includes(this.formGroup.controls['mode_of_transportation'].value)) && this.formGroup.controls['transportation_cost'].value === '') {
      this.formKey('transportation_cost');
    }


    if (!this.formGroup.invalid) {

      let hasDupsObjects = function(array) {

          return array.map(function(value) {

            let origin_country = (value.origin_country) ? value.origin_country : "";
            let origin_city_municipality = (value.origin_city_municipality) ? value.origin_city_municipality : "";
            let origin_barangay = (value.origin_barangay ) ? value.origin_barangay : "";
            let destination_country = (value.destination_country) ? value.destination_country : "";
            let destination_city_municipality = (value.destination_city_municipality) ? value.destination_city_municipality : "";
            let destination_barangay = (value.destination_barangay) ? value.destination_barangay : "";

            return origin_country + origin_city_municipality + origin_barangay + destination_country + destination_city_municipality + destination_barangay

          }).some(function(value, index, array) { 
            return array.indexOf(value) !== array.lastIndexOf(value);
          })
      };

      let summary_list = [];
      let summaryValue = this.formGroup.getRawValue();
      summary_list.push(summaryValue);

      let updated_list = this.travel.summary_list;
      let final_list = summary_list.concat(updated_list);

      let hasDuplicate = hasDupsObjects(final_list);

      let travelBookings = this.formGroup.controls['travel_itinerary_bookings'].value
      let bookingDuplicate: boolean = false
      //If there's duplicate bookings, throw an error
      for(let i = 1; i < travelBookings.length; i++){
        if(travelBookings[0].departure_date == travelBookings[i].departure_date && travelBookings[0].arrival_date == travelBookings[i].arrival_date){
          if(travelBookings[0].departure_time == travelBookings[i].departure_time && travelBookings[0].arrival_time == travelBookings[i].arrival_time){
            bookingDuplicate = true
          }
        }
        else{
          bookingDuplicate = false
        }
      }

      if (hasDuplicate) {
        this.dialog.open(NotifyboxComponent, {
          disableClose:true,
          data: {
            reload:false,
            label:'Ok',
            isclose:true,
            message: 'Transportation details should be unique.'
          }
        }).afterClosed().subscribe(result => {
          this.travel._errors = {};
        });
      } else {
        if(bookingDuplicate == true){
          if(bookingDuplicate == true){
            this.dialog.open(NotifyboxComponent, {
              disableClose:true,
              data: {
                reload:false,
                label:'Ok',
                isclose:true,
                message: 'Travel Bookings should be unique.'
              }
            }).afterClosed().subscribe(result => {
              this.travel._errors = {};
            });
          }
        }

        if(bookingDuplicate == false){
        this.travel.setSummaryList(this.formGroup.getRawValue());
        this.dialog.open(NotifyboxComponent, {
          disableClose:true,
          data: {
            reload:false,
            label:'Ok',
            isclose:true,
            message: 'Itinerary has been added.'
          }
        }).afterClosed().subscribe(result => {
          this.travel.booking_details_temp = [];
          this.travel._errors = {};
          if (result) {
            this.dialogRef.close(this.travel);
          }
        });
        }
      }
    }
  }

  close() {
    this.dialogRef.close(this.travel);
  }

  formKey(key?:string) {
    this.formGroup.controls[key].setErrors({'invalid': true});
    this.formGroup.controls[key].markAsTouched();
    this.formGroup.controls[key].markAsDirty();
  }

  changeCity(id,option?:string,val?:string){
    this.addressService.getCity(id).subscribe(res=>{
      this.city = res;
      this.cityList[option] = res;
      if (option == 'origin') {
        this.formGroup.get('origin_city_municipality').valueChanges.subscribe(value => {
          this.formGroup.controls['origin_barangay'].setValue('');
        });
        this.filtercityOrigin = this.formGroup.get('origin_city_municipality').valueChanges
        .pipe(startWith(''),map(val => this._filter(val,2,option)));    
      } else if (option == 'destination') {
        this.formGroup.get('destination_city_municipality').valueChanges.subscribe(value => {
          this.formGroup.controls['destination_barangay'].setValue('');
        });
        this.filtercityDestination = this.formGroup.get('destination_city_municipality').valueChanges
        .pipe(startWith(''),map(val => this._filter(val,2,option)));
      }
    });
    this.autosuggest[option] = val;
  }

  changeCountry(e,controlName?:string) {
    this.formGroup.controls['origin_barangay'].disable();
    if (e) {
      if (e.toLocaleLowerCase() == "philippines") {
        this.isCountry = false;
        this.formGroup.controls['origin_city_municipality'].enable();
        this.formGroup.controls['origin_barangay'].enable();
      } else {
        this.isCountry = true;
        this.formGroup.controls['origin_city_municipality'].clearValidators();
        this.formGroup.controls['origin_barangay'].clearValidators();
      }
      this.formGroup.controls['origin_city_municipality'].updateValueAndValidity();
      this.formGroup.controls['origin_barangay'].updateValueAndValidity();
  
      this.formGroup.controls['origin_city_municipality'].setValue('');
      this.formGroup.controls['origin_barangay'].setValue('');
      this.autosuggest[controlName] = e;
    }
  }

  selectSuggest(e,control?:string,mode?:number,option?:string){
    let valid = this._filter(e,mode,option);
    if (valid.length == 1 && (e.length == valid[0].length)) {
      //this.autosuggest[control] = e;
      if (mode == 0 && option == 'origin') {
        this.changeCountry(this.autosuggest[control],control);
      } else if (mode == 0 && option == 'destination') {
        this.changeDestinationCountry(this.autosuggest[control],control);
      }
    }
  }

  changeDestinationCountry(e,controlName?:string) {
    this.formGroup.controls['destination_barangay'].disable(); 
    if (e) {
      if (e.toLocaleLowerCase() == "philippines") {
        this.isDestinationCountry = false;
        this.formGroup.controls['destination_city_municipality'].enable();
        this.formGroup.controls['destination_barangay'].enable(); 
      } else { 
        this.isDestinationCountry = true;
        this.formGroup.controls['destination_city_municipality'].clearValidators();
        this.formGroup.controls['destination_barangay'].clearValidators();
      }
      this.formGroup.controls['destination_city_municipality'].updateValueAndValidity();
      this.formGroup.controls['destination_barangay'].updateValueAndValidity();   
      
      this.formGroup.controls['destination_city_municipality'].setValue('');
      this.formGroup.controls['destination_barangay'].setValue(''); 
      this.autosuggest[controlName] = e; 
    }
  }

  changeBarangay(id,option?:string,controlName?:string,val?:string){
    this.addressService.getBarangay(id).subscribe(res=>{
      this.barangay = res;
      this.barangayList[option] = res;
      if (option == 'origin') {
        this.filterBarangayOrigin = this.formGroup.get('origin_barangay').valueChanges
        .pipe(startWith(''),map(val => this._filter(val,3,option)));    
      } else {
        this.filterBarangayDestination = this.formGroup.get('destination_barangay').valueChanges
        .pipe(startWith(''),map(val => this._filter(val,3,option)));
      }
    });
    this.autosuggest[controlName] = val;
  }
  
  selectBarangay(e,controlName?:string){
    this.autosuggest[controlName] = e;
  }

  displayBook(e) {
    this.isBook = false;
  }

  getProvince(){
    // this.addressService.getProvince().subscribe(res=>{
    //   this.province[0].origin = res;
    //   this.province[1].destination= res;
    // });
  }

  getCountry(){
    // this.addressService.getCountry().subscribe(res=>{
    //   this.country[0].origin_country = res;
    //   this.country[1].destination_country= res;
    // });
  }

  /**
   * Create Booking
   */
  createBooking(){
    this.dialogConfig.width = '100vw';
    this.dialogConfig.data = {
      mode: 0,
      travel: this.travel
    }
    let dialogRef = this.dialog.open(TravelBookingAddComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result != '') {
        this.travel.setBooking(result);
        this.isBookrequired = false;
        this.formGroup.controls['travel_itinerary_bookings'].setValue(this.travel.booking_details_temp);
        this.formGroup.controls['travel_itinerary_bookings'].disable();
      }
    });
  }

  
  /**
   * Booking add Detail
   * mode temporary data
   * @param res 
   */
  editBooking(res,i) {
    this.dialogConfig.width = '100vw';
    this.dialogConfig.data = {
      res,
      list:this.travel.booking_details_list,
      mode: 0,
      index:i,
      is_draft:true,
      itinerary_date: this.travel.itinerary_date
    }
    let dialogRef = this.dialog.open(TravelBookingViewComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result != '') {
        // this.travel.booking_details_list = result;
        this.formGroup.controls['travel_itinerary_bookings'].disable();
        // this.formGroup.controls['travel_itinerary_bookings'].setValue(this.travel.booking_details_temp);
      }
    });
  }

  deleteBooking(i){
    let dialogRef = this.dialog.open(ConfirmationMessageComponent, {
      disableClose:true,
      data: {
        message: "Are you sure you want to delete this booking? "
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deletebookingmsg();
      }
    });
    this.index = i;
  }

  deletebookingmsg() {
    this.removeRow(this.index,this.travel.booking_details_temp);
    this.removeRow(this.index,this.travel.booking_details_list);
    this.formGroup.controls['travel_itinerary_bookings'].enable();
    if (this.travel.booking_details_temp.length > 0) {
      this.formGroup.controls['travel_itinerary_bookings'].disable();
    }
    let book = (this.travel.booking_details_temp.length > 0)? this.travel.booking_details_temp : '' ;
    this.formGroup.controls['travel_itinerary_bookings'].setValue(book);
    this.bookingmsg = "";
    this.dialog.open(NotifyboxComponent, {
      disableClose:true,
      data: {
        reload:false,
        label:'Ok',
        message: 'Booking has been deleted.'
      }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.dialogRef.close(this.data.list);
      }
    });
    this.index = 0;
  }

  closeBooking() {
    this.bookingmsg = "";
    this.index = 0;
  }


  /**
   * Remove in Object Array
   * @param index index key
   * @param data list
   */
  removeRow(index,data){
    data.splice(index, 1);
  }

  private _filter(name: string,mode = 0,option?:string): string[] {
    const filterValue = name.toLowerCase();
    if (mode == 0) {
      return this.country.filter(option => option.toLowerCase().includes(filterValue));
    } else if(mode == 2) {  
      return this.cityList[option].filter(option => option.title.toLowerCase().includes(filterValue));
    } else if(mode == 3) {  
      return this.barangayList[option].filter(option => option.brgyDesc.toLowerCase().includes(filterValue));
    } else {
      return this.province.filter(option => option.provDesc.toLowerCase().includes(filterValue));
    }
  }

  /**
   * 1 = country
   * 2 = province
   * 3 =  city
   * 4 = barangay
   * @param i 
   */
  locationLookUp(i?:number,formInput?:string,mode?:string){
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.width = '605px';
    this.dialogConfig.data = {
        i,
        city: (this.cityList[mode])? this.cityList[mode] : null,
        barangay: (this.barangayList[mode])? this.barangayList[mode] : null
    }
    let dialogRef = this.dialog.open(LookUpLocationComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result.value) {
        if (i == 1) {
          this.formGroup.controls[formInput].setValue(result.value);
          if (mode == 'origin') {
            this.changeCountry(result.value,formInput);
          } else {
            mode = 'destination'
            this.changeDestinationCountry(result.value,formInput);
          }
        } else if (i == 2) {
          this.formGroup.controls[formInput].setValue(result.value.provDesc);
          this.changeCity(result.value.provCode,mode);
          this.autosuggest[formInput] = result.value.provDesc;
        } else if (i == 3) {
          this.formGroup.controls[formInput].setValue(result.value.citymunDesc);
          this.changeBarangay(result.value.citymunCode,mode);
          this.autosuggest[formInput] = result.value.citymunDesc;
        } else {
          this.formGroup.controls[formInput].setValue(result.value);
          this.autosuggest[formInput] = result.value;
        }
      }
    });
  }

}
